import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<path d=\"M12 0H2C0.875 0 0 0.90625 0 2V12C0 13.125 0.875 14 2 14H12C13.0938 14 14 13.125 14 12V2C14 0.90625 13.0938 0 12 0ZM9.96875 7.75H7.71875V10C7.71875 10.4375 7.375 10.75 7 10.75C6.5625 10.75 6.25 10.4375 6.25 10V7.75H3.96875C3.5625 7.75 3.21875 7.4375 3.21875 7C3.21875 6.59375 3.53125 6.25 3.96875 6.25H6.1875V4C6.1875 3.59375 6.53125 3.25 6.9375 3.25C7.34375 3.25 7.65625 3.59375 7.65625 4V6.25H9.90625C10.3125 6.25 10.625 6.59375 10.625 7C10.7188 7.4375 10.4062 7.75 9.96875 7.75Z\" fill=\"#C4C4C4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/plus.svg
// module id = 8Emb
// module chunks = 13